// import axios from 'axios';
import Vue from "vue";
import store from "../index.js";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {
  _cart: {
    info: {},
  },
  _complete: [],
  _error: {
    code: 0,
    message: "",
  },
};

export const mutations = {
  setOrderCartInfo(state, item) {
    state._cart.info = item;
  },
  setCompleteNo(state, items) {
    state._complete = items;
  },
  setResetCompleteNo(state) {
    state._complete = [];
  },
  setOrderError(state, payload) {
    state._error = payload;
  },
};

export const actions = {
  async acOrderCommit({ commit, rootState }, { imp_uid, merchant_uid, status, pg_name }) {
    try {
      const params = {
        imp_uid: imp_uid,
        merchant_uid: merchant_uid,
        status: status,
        pg_name: pg_name,
      };
      window.console.log("params", params);
      const res = await api.post(`/api/v1/order/complete`, params);
      window.console.log("acOrderCommit", res);
      if (res.data.code !== 0) {
        const url = `/api/v1/amount-fail-log`;
        await api.post(url, {
          imp_uid: imp_uid,
          merchant_uid: merchant_uid,
          error_code: res.data.code,
          error_msg: res.data.message,
        });
      }
      if (res.data?.data?.firstPurchase) {
        Vue.prototype.$mixpanel_track("First-time-purchase");
      }

      // 주문 번호를 Root Store의 _items.order에 저장
      const orderSeq =
        res.data?.id ||
        res.data?.order_seq ||
        res.data?.orderSeq ||
        res.data?.data?.id ||
        res.data?.data?.order_seq ||
        res.data?.data?.orderSeq;

      if (orderSeq && rootState._items?.order) {
        const updatedOrder = {
          ...rootState._items.order,
          order_seq: orderSeq,
        };
        commit("setContinueOrder", updatedOrder, { root: true });
      }

      const encryptedOrderSeq = res.data?.data?.encrypted_order_seq;
      if (encryptedOrderSeq) {
        commit("setEncryptedOrderSeq", encryptedOrderSeq, { root: true });
      }

      return res;
    } catch (error) {
      window.console.log("acOrderCommit error message", error);
      if (error.response.status === 401) {
        localStorage.clear();
        console.log(commit);
      } else {
        return false;
      }
    }
  },
  async acIsOrderCoupon({ commit }) {
    try {
      const url = `/api/v1/order-coupons/user`;
      const res = await api.get(url);
      return res.data?.code === 0 && res.data?.data?.status;
    } catch (error) {
      console.log(commit);
      return false;
    }
  },
  async acIsOrderCouponCheck({ commit }) {
    try {
      const url = `/api/v1/order-coupons/user/confirm`;
      const res = await api.get(url);
      return res.data.message;
    } catch (error) {
      console.log("acIsOrderCouponCheck error", error);
      console.log(commit);
      return error.response.data.message;
    }
  },
  async acOrderCart({ commit }, order_seq) {
    try {
      const res = await api.get(
        `/api/v1/order/detail/realtor?order_seq=${encodeURIComponent(order_seq)}`,
      );

      commit("setOrderCartInfo", res.data.data);
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        console.log(commit);
        return false;
      } else {
        alert(error.response.data.message);
        return false;
      }
    }
  },
  async acOrderIrosUpdate({ commit }, params) {
    try {
      const res = await api.patch(
        `/api/v1/order-carts/iros/${encodeURIComponent(params.merchant)}`,
        {
          unique_no: params.estate_code,
          bunji: params.estate_bunji,
          confirm: params.confirm,
          address: params.estate_address,
        },
      );
      return true;
    } catch (error) {
      if (error.response.data?.code === 2511) {
        alert("수정시간이 초과되었습니다.");
        return true;
      } else {
        return false;
      }
    }
  },
  async acOrderIrosReinput({ commit }, params) {
    try {
      await api.patch(`/api/v1/order-carts/iros-reinput/${encodeURIComponent(params.merchant)}`, {
        unique_no: params.estate_code,
        bunji: params.estate_bunji,
        address_iros: params.address_iros,
        address: params.address,
        address_jibun: params.address_jibun,
        building_name: params.building_name,
        building_ho: params.building_ho,
        building_floor: params.building_floor,
      });
      return { success: true };
    } catch (error) {
      const code = error.response?.data?.code;
      return { success: false, code };
    }
  },
  async acOrderIros({ commit }, params) {
    console.log("paramssss", params);
    try {
      const res = await api.get(
        `/api/v1/order-carts/iros/${encodeURIComponent(params.merchant_uid)}`,
      );
      return true;
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        console.log(commit);
        return false;
      } else {
        alert(error.response.data.message);
        return false;
      }
    }
  },
  async acOnceOrder({ commit }, body) {
    try {
      const url = `/api/v1/order/once-complete`;
      const res = await api.post(url, body);
      return res.data?.code === 0 ? true : false;
    } catch (error) {
      console.log(commit);
      return false;
    }
  },

  async acCouponOnceOrder({ commit }, body) {
    try {
      const url = `/api/v1/order/coupon/once-complete`;
      const res = await api.post(url, body);
      return res.data?.code === 0 ? true : false;
    } catch (error) {
      console.log(commit);
      return false;
    }
  },

  async acOrderDeterminedList({ commit }) {
    const url = `/api/v1/order-determined/recent`;
    try {
      const res = await api.get(url);
      return res.data.data;
    } catch (error) {
      return false;
    }
  },

  /**
   * 프리미엄 업그레이드 주문 초기화
   * order_type: 16
   * @param {Object} payload - { user_no, email, price, pg_name, order_type, report_seq }
   */
  async acOrderInitPremiumUpgrade({ commit }, payload) {
    try {
      const url = "/api/v1/order/premium-upgrade";
      const res = await api.post(url, payload);
      return {
        success: res.data?.code === 0,
        data: res.data?.data,
      };
    } catch (error) {
      console.log("acOrderInitPremiumUpgrade error", error);
      commit("setOrderError", {
        code: error.response?.data?.code || 9999,
        message: error.response?.data?.message || "주문 생성 실패",
      });
      return {
        success: false,
        error: error.response?.data?.message || "주문 생성 실패",
      };
    }
  },

  async acOrderInitPremiumUpgradePending({ commit }, payload) {
    try {
      const url = "/api/v1/order/premium-upgrade-pending";
      const res = await api.post(url, payload);
      return {
        success: res.data?.code === 0,
        data: res.data?.data,
      };
    } catch (error) {
      commit("setOrderError", {
        code: error.response?.data?.code || 9999,
        message: error.response?.data?.message || "업그레이드 주문 생성 실패",
      });
      return {
        success: false,
        error: error.response?.data?.message || "업그레이드 주문 생성 실패",
      };
    }
  },

  /**
   * 퍼스트아메리칸(안심 매매 패키지) 결제 기본정보 등록 — order 전환(NZSC-3189).
   * order(order_type=18) + cart(매매) + firstam draft 생성 + 페이플 인증을 한 번에.
   * @param {Object} payload - { pg_name, sale_amount, balance_date, contract_date, unique_no, address, address_jibun, building_dong, building_floor, building_ho, survey_json }
   * @returns {Object} { success, data: { merchant_uid, user_name, user_no, email, mobile, AuthKey, return_url, product_name } }
   */
  async acFirstamericanOrderInit({ commit }, payload) {
    try {
      const url = "/api/v1/order/firstamerican";
      const res = await api.post(url, payload);
      return {
        success: res.data?.code === 0,
        data: res.data?.data,
      };
    } catch (error) {
      console.log("acFirstamericanOrderInit error", error);
      commit("setOrderError", {
        code: error.response?.data?.code || 9999,
        message: error.response?.data?.message || "주문 생성 실패",
      });
      return {
        success: false,
        error: error.response?.data?.message || "주문 생성 실패",
      };
    }
  },

  /**
   * [로컬/dev 테스트 전용] PG 없이 order 결제완료 시뮬(POST /order-test/complete).
   * BE가 impCompleteOrder('paid') → ConfirmOrderHandler FA훅(REVIEW_1ST + cold). prod 차단.
   * @param {Object} payload - { merchant_uid }
   */
  async acOrderTestComplete({ commit }, payload) {
    try {
      const url = "/api/v1/order-test/complete";
      const res = await api.post(url, payload);
      return !!res?.data;
    } catch (error) {
      console.log("acOrderTestComplete error", error);
      commit("setOrderError", {
        code: error.response?.data?.code || 9999,
        message: error.response?.data?.message || "테스트 완료 처리 실패",
      });
      return false;
    }
  },

  acCompleteNo({ commit }, items) {
    commit("setCompleteNo", items);
  },
  acResetCompleteNo({ commit }) {
    commit("setResetCompleteNo");
  },
};

export const getters = {
  geCodeFail: state => {
    switch (state._error.code) {
      case 2000:
        return "인증에 실패했습니다. 다시 시도해 주세요.";
      case 2001:
        return "인증에 실패했습니다. 다시 시도해 주세요.";
      case 2500:
        return "결제 타입이 올바르지 않습니다.";
      case 2501:
        return "결제 정보 분석이 진행중입니다. 잠시 후 다시 시도해 주세요.";
      case 2502:
        return "기존 리포트 승인이 필요합니다.";
      case 2503:
        return "결제 정보를 찾을 수 없습니다.";
      case 2504:
        return "결제 요청에 실패했습니다. 다시 시도해 주세요.";
      case 2508:
        return "결제 인증에 실패했습니다.";
      case 2509:
        return "결제 정보를 찾을 수 없습니다.";
      case 2510:
        return "결제가 완료되지 않았습니다.";
      case 2511:
        return "주소 수정 가능 시간(5분)이 초과되었습니다.";
      case 2512:
        return "공인중개사는 쿠폰을 사용할 수 없습니다.";
      case 2513:
        return "주문 정보를 찾을 수 없습니다.";
      case 2514:
        return "주소 미정 상태가 올바르지 않습니다.";
      case 2515:
        return "주소지 상태가 올바르지 않습니다.";
      case 2516:
        return "동/층/호 정보 상태가 올바르지 않습니다.";
      default:
        return "시스템 오류입니다. 다시 시도해 주세요.";
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
